import './App.css';
// SOULUTION USING REACT HOOKS: import Main from './component/Main';
import Metronome from './component/Metronome';

function App() {
	return (
		<div className="app">
			<Metronome />
			{/* <Main /> */}
		</div>
	);
}

export default App;
